import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import {
  legalEntityKeys,
  legalEntityRepository,
} from '@webapp/platform/legal-entities/data-access/repositories/LegalEntityRepository'
import { type CreateLegalEntityInput } from '@webapp/platform/legal-entities/data-access/types/CreateLegalEntityInput'
import { LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'

/**
 * Creates a LegalEntity and invalidates the cached LegalEntity list so the
 * Active/Inactive tabs refetch with the new record.
 */
export const useMutateCreateLegalEntity = () => {
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading, isSuccess, isError, error } = useMutation<
    LegalEntity,
    RepoError,
    CreateLegalEntityInput
  >({
    mutationFn: async (input: CreateLegalEntityInput) => {
      const constructor = await legalEntityRepository.create(input)

      return new LegalEntity(constructor)
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: legalEntityKeys.list })
    },
  })

  return { mutateAsync, isLoading, isSuccess, isError, error }
}
